import React from 'react';
import ReadOnly from '../../ui-framework/components/Forms/ReadOnly';

/**
 * Currency Component
 * Handles display of amounts safely with formatting and fallbacks
 *
 * Props:
 * - children: number | string | null | undefined
 * - currency: string (default: "USD")
 * - locale: string (default: "en-US")
 * - hideZero: boolean (default: false) => hides "0" and "0.00"
 * - placeholder: string (default: "-") => shown for null/undefined/invalid
 * - minimumFractionDigits: number (default: 2)
 * - maximumFractionDigits: number (default: 2)
 */
function Currency({ color = null, children }) {
  // Convert and validate number
  const numericchildren = Number(children);

  if (
    children === null ||
    children === undefined ||
    Number.isNaN(numericchildren)
  ) {
    return <ReadOnly {...(color && { color })}>{children}</ReadOnly>;
  }

  try {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return (
      <ReadOnly {...(color && { color })}>
        {formatter.format(numericchildren)}
      </ReadOnly>
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Currency format error:', err);
    return (
      <ReadOnly {...(color && { color })}>{JSON.stringify(children)}</ReadOnly>
    );
  }
}

export default Currency;
